import React, { useState } from 'react'
import ProFeatureLabel from 'components/ProFeatureLabel'
import { Button } from 'semantic-ui-react'
import useAxios from 'hooks/useAxios'
import { getAxios } from 'api'
import { toast } from 'libs/toast'
import * as R from 'ramda'
import usePermission from 'hooks/usePermission'
import constants from 'config/constants'

export default function AuditLog({ userInfo }) {
  const endbledAuditLogBaseOnCompany = userInfo.billing.enable_audit_log
  const [isPortalLinkLoading, setIsPortalLinkLoading] = useState(false)
  const { hasPermission } = usePermission()

  const hasAuditLogsPermission = hasPermission(constants.permissions.accessAuditLogs)

  const { data: enabledAuditLog, loading: loadingEnabledAuditLog } = useAxios({
    url: 'billing/plans/feature-toggle/',
    method: 'post',
    data: { feature: 'audit_log' },
  })
  const endbledAuditLogBaseOnProPlan = R.path(['enabled'], enabledAuditLog)

  function handleAuditLogClick() {
    setIsPortalLinkLoading(true)
    getAxios()
      .get('sso/audit-log/')
      .then((res) => {
        setIsPortalLinkLoading(false)
        window.open(res.data.link)
      })
      .catch(() => {
        setIsPortalLinkLoading(false)
        toast.error('Oops! Something went wrong. Please try again.')
      })
  }

  return (
    <React.Fragment>
      <h3 className="flex items-center ui header">
        Audit logs
        <ProFeatureLabel
          title="Audit logs"
          content="
              Gain visibility into user activity with comprehensive audit logs, enabling more
              effective oversight and improved security."
          learnMoreLink="https://help.simplesat.io/en/articles/8340338-audit-logs"
          shouldShowBillingPageLink={!loadingEnabledAuditLog && !endbledAuditLogBaseOnProPlan}
        />
      </h3>
      <p>
        <a
          href="https://help.simplesat.io/en/articles/8340338-audit-logs"
          target="_blank"
          rel="noreferrer"
        >
          <i className="icon far fa-book" />
          Learn more about audit logs
        </a>
      </p>

      {endbledAuditLogBaseOnProPlan &&
        (endbledAuditLogBaseOnCompany ? (
          <div className="mb-3">
            <Button
              loading={isPortalLinkLoading}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                handleAuditLogClick()
              }}
              disabled={!hasAuditLogsPermission}
            >
              View audit logs
            </Button>
          </div>
        ) : (
          <div className="!my-2">
            <div
              className="ui secondary segment"
              style={{
                background: '#E6F2FF',
                border: '1px solid #66B2FF',
                borderRadius: '5px',
              }}
            >
              <div className="twelve column right aligned">
                <div className="flex justify-between items-center">
                  <div className="flex flex-col">
                    <h4 style={{ color: '#373f46' }}>
                      Audit logs need to be enabled by Simplesat support
                    </h4>
                    <p style={{ color: '#373f46', marginTop: -10 }}>
                      Please contact Simplesat support to learn more and configure.
                    </p>
                  </div>
                  <a>
                    <button
                      className="ui primary button"
                      id="request-audit-logs"
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                    >
                      Contact support
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/AuditLog/index.js